import { useMemo } from "react";

import { formatDate } from "~/utils/formatDate";
import {
  type EndDateInput,
  getEndsInDisplay,
  toFormatDateInput,
  toValidDate,
} from "~/utils/formatDateCounter";

export function useFormatDateCounter(endDate: EndDateInput): {
  formattedTime: string;
  isError: boolean;
  tooltipTitle: string | null;
  isPast: boolean;
} {
  return useMemo(() => {
    const endDateAsDate = toValidDate(endDate);
    if (!endDateAsDate) {
      return {
        formattedTime: "",
        isError: false,
        tooltipTitle: null,
        isPast: false,
      };
    }

    const { formattedTime, isError, isPast } = getEndsInDisplay(endDateAsDate);
    const tooltipTitle = formatDate(toFormatDateInput(endDateAsDate), {
      includeYear: true,
    });

    return { formattedTime, isError, isPast, tooltipTitle };
  }, [endDate]);
}
